import { metadataH2 } from "app/brands/components/BrandMetadataPanel"
import { SocialLink } from "app/brands/components/SocialLink"
import { SocialLinkableVM } from "app/models"
import useTranslation from "next-translate/useTranslation"
import { FC } from "react"
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaPinterest,
  FaTiktok,
  FaTwitter,
  FaVimeo,
  FaYoutube,
} from "react-icons/fa"
import { tw } from "twind"

interface BrandSocialLinkListProps {
  socialLinkable: SocialLinkableVM
}

export const BrandSocialLinkList: FC<BrandSocialLinkListProps> = ({
  socialLinkable: socialLinkable,
}) => {
  const { t } = useTranslation("brands")

  return (
    <div>
      <h2 className={tw(metadataH2)}>{t("social-media")}</h2>

      <ul className={tw(`flex(& wrap) gap-4`)}>
        <SocialLink
          Icon={FaFacebook}
          hexColor="#3b5998"
          socialName="Facebook"
          url={socialLinkable.facebookUrl}
        />
        <SocialLink
          Icon={FaInstagram}
          hexColor="#7232bd"
          socialName="Instagram"
          url={socialLinkable.instagramUrl}
        />
        <SocialLink
          Icon={FaLinkedin}
          hexColor="#0a66c2"
          socialName="LinkedIn"
          url={socialLinkable.linkedInUrl}
        />
        <SocialLink
          Icon={FaPinterest}
          hexColor="#bd081c"
          socialName="Pinterest"
          url={socialLinkable.pinterestUrl}
        />
        <SocialLink
          Icon={FaTiktok}
          hexColor="#ee1d52"
          socialName="TikTok"
          url={socialLinkable.tikTokUrl}
        />
        <SocialLink
          Icon={FaTwitter}
          hexColor="#1da1f2"
          socialName="Twitter"
          url={socialLinkable.twitterUrl}
        />
        <SocialLink
          Icon={FaVimeo}
          hexColor="#1ab7ea"
          socialName="Vimeo"
          url={socialLinkable.vimeoUrl}
        />
        <SocialLink
          Icon={FaYoutube}
          hexColor="#ff0000"
          socialName="YouTube"
          url={socialLinkable.youTubeUrl}
        />
      </ul>
    </div>
  )
}
